module.exports = __webpack_public_path__ + "img/user.bk1.f940f317.png";